import(/* webpackMode: "eager", webpackExports: ["Participants"] */ "/app/apps/web/app/(app)/tournaments/[tournamentId]/scoring/participants/components/participants.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/core/src/cache/client-cache-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/core/src/config/client-config-provider.tsx");
